module.exports = __webpack_public_path__ + "img/pc_p3_handle.90329007.svg";